var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"readonly props-group"},[_c('el-form-item',{attrs:{"label":"只读"}},[_c('el-checkbox',{model:{value:(_vm.component.properties.readonly),callback:function ($$v) {_vm.$set(_vm.component.properties, "readonly", $$v)},expression:"component.properties.readonly"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbbb493e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/componentAttr/readonly.vue
// module id = null
// module chunks = 